function Button({
  as: Tag = "button",
  variant = "primary",
  className = "",
  children,
  type = "button",
  ...props
}) {
  const variants = {
    primary:
      "bg-accent text-white hover:bg-accentSoft hover:shadow-[0_12px_30px_rgb(var(--color-accent)/0.22)] active:bg-accent",
    secondary:
      "border border-border/80 bg-surface/35 text-primary hover:border-accent/45 hover:bg-surface/55 hover:text-accent active:bg-surface/70",
    ghost: "text-secondary hover:text-primary"
  };

  return (
    <Tag
      className={`inline-flex min-h-10 items-center justify-center rounded-xl px-4 text-sm font-medium transition-all duration-200 ease-in-out active:translate-y-px focus-visible:shadow-focus-ring disabled:pointer-events-none disabled:opacity-50 ${variants[variant]} ${className}`}
      type={Tag === "button" ? type : undefined}
      {...props}
    >
      {children}
    </Tag>
  );
}

export default Button;
